import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, take } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({ providedIn: 'root' })
export class EfsBaseService {

  constructor(
    public http: HttpClient,
    public oidcSecurityService: OidcSecurityService,
  ) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': environment.apiEndpoint,
      Authorization: 'Bearer ' + this.token(),
    }),
  };

  apiUrl(endpoint: string, version: string = 'v1'): string {
    const host: string = environment.apiEndpoint;
    const url = `${host}/${endpoint}`;
    // const url = `${host}/${version}/${endpoint}`;
    return url;
  }

  token(): string {
    let accessToken = '';
    if (this.oidcSecurityService) {
      this.oidcSecurityService.getAccessToken().pipe(take(1)).subscribe(token => {
        accessToken = token;
      })
    }
    return accessToken;
  }

  query<T>(
    http: HttpClient,
    baseUrl: string,
    urlOrFilter?: string | object,
    httpOptions?: any,
  ): Observable<T> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': environment.apiEndpoint,
        Authorization: 'Bearer ' + this.token(),
      }),
    };

    const headers = this.httpOptions.headers;
    const options = { headers };
    return http.get<T>(baseUrl, options);
  }

  queryPost<T>(
    http: HttpClient,
    baseUrl: string,
    body: any,
    httpOptions?: any,
  ): Observable<T> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': environment.apiEndpoint,
        Authorization: 'Bearer ' + this.token(),
      }),
    };

    const headers = this.httpOptions.headers;
    const options = { headers };
    return http.post<T>(baseUrl, body, options);
  }
}
